export default "__VITE_ASSET__BIF_XoH7__"